import { Field } from 'formik'
import PropTypes from 'prop-types'
import React from 'react'
import SingleInputSelect from '../SingleInputSelect'

const propTypes = {
  /**
   * id of the field. The id passed is also bound to the field's name
   */
  id: PropTypes.string.isRequired,
  /**
   * If exists, calls it with the value for custom additional actions
   * Formik setFieldValue will always run before it
   */
  onChange: PropTypes.func,
  /**
   * When true, show validation errors even if the field was not blurred yet.
   */
  showErrorWhenInvalid: PropTypes.bool,
}

/**
 * Connects the SingleInputSelect with Formik.
 */
function FormikSingleSelect(props) {
  const { id, onChange = null, showErrorWhenInvalid = false } = props ?? {}

  return (
    <Field name={id}>
      {({ field, meta, form }) => (
        <SingleInputSelect
          {...props}
          id={id}
          name={id}
          onChange={(value) => {
            // Convert null to undefined for Formik (null causes React warnings for controlled inputs)
            const formValue = value === null ? undefined : value
            form.setFieldValue(id, formValue)
            if (onChange) {
              onChange(formValue)
            }
          }}
          onBlur={() => {
            form.setFieldTouched(id, true) // set the touched flag (important for displaying errors)
          }}
          values={field.value ?? null}
          errors={(showErrorWhenInvalid || meta.touched) && meta.error ? [meta.error] : []}
        />
      )}
    </Field>
  )
}

FormikSingleSelect.propTypes = propTypes

export default FormikSingleSelect
